<template>
  <main-layout>
    <search-filter
        :tags="tags"
        v-model="filter"
        @input="resetData"
    />
    <div class="p-4">
      <exercice-band
          title-class="text-primary"
          :list="list"
          :loading="loading"
      />
    </div>
    <b-pagination
        v-if="count > perPage"
        v-model="page"
        :per-page="perPage"
        :total-rows="count"
        @input="getData"
        align="center"
    />
  </main-layout>
</template>

<script>
import MainLayout from "@/components/Nav/MainLayout";
import ExerciceBand from "@/components/ExerciceBand";
import {Produit} from "@/js/caller";
import {DataFormat} from "@/js/utils";
import SearchFilter from "@/components/SearchFilter";

export default {
  name      : "ProduitEditorList",
  components: {SearchFilter, ExerciceBand, MainLayout},
  data() {
    return {
      list   : [],
      count  : 0,
      loading: 0,
      tags   : [],
      filter : {
        niveau: [],
        tags  : []
      },
      page   : 1,
      perPage: 20,
    }
  },
  methods: {
    getFilter() {
      const {filter} = this;
      const res      = {
        Null: [{field: "pe.exercice", isNot: true}]
      }
      if (filter.niveau.length) {
        res.In = [
          ...(res.In || []),
          {field: "ee.niveau", values: filter.niveau}
        ]
      }
      if (filter.tags.length) {
        res.In = [
          ...(res.In || []),
          {field: "et.tag", values: filter.tags}
        ]
      }
      return res
    },
    getCount() {
      Produit.Count(this.getFilter()).then(count => {
        this.count = count;
      });
    },
    getData(input = 1) {
      this.loading = Math.min(this.perPage, this.count - this.perPage * (input - 1));
      Produit.List(
          {
            ...this.getFilter(),
            Offset: (input - 1) * this.perPage,
            Limit : this.perPage
          }
      ).then(res => {
        // Inject the first exercice in the produit
        res          = DataFormat.Produits(res);
        this.list    = res;
        this.loading = 0;
      });
    },
    resetData() {
      this.getCount();
      this.page = 1;
      this.getData();
    }
  },
  created() {
    Produit.Tags().then(tags => this.tags = tags)
    this.getCount();
    this.getData();
  }
}
</script>

<style scoped>

</style>